import {
  DialogTitle,
  Dialog,
  DialogContent,
  Button,
  DialogActions,
  Box,
  DialogContentText,
} from "@mui/material";
import React from "react";
import {LoadingButton} from "@mui/lab";

function AlertDialog({
  open,
  onClose,
  title,
  description,
  onConfirm,
  svgFile,
  isAlert,
}) {
  return (
    <>
      <Dialog open={open} onClose={onClose}>
        <DialogContent sx={{textAlign: "center"}}>
          <Box sx={{svg: {height: "100%", width: "100%"}}}>{svgFile}</Box>
          <DialogTitle sx={{pb: 1, pt: 0}}>{title}</DialogTitle>
          {description && <DialogContentText>{description}</DialogContentText>}
        </DialogContent>
        <DialogActions>
          {!isAlert && (
            <>
              <Button onClick={onClose}>Cancel</Button>
              <LoadingButton
                autoFocus
                onClick={() => {
                  onConfirm(open);
                  onClose();
                }}
                variant="contained"
              >
                Confirm
              </LoadingButton>
            </>
          )}
          {isAlert && (
            <Button variant="contained" onClick={onConfirm}>
              Ok
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
}

export default AlertDialog;